module.exports = __webpack_public_path__ + "gamecode/img/zroute_favicon.png?ef189c80";